import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  container: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    // marginTop: 64,
    alignItems: "center",
    marginBottom: 32,
    padding: "0 72px 0 72px",
    maxWidth: 1600,
    margin: "auto",
    [theme.breakpoints.down("xl")]: {
      padding: "0 32px",
    },
  },

  body: {
    marginTop: -64,
    paddingBottom: 32,
    minHeight: 640,
    background: "url(/assets/imgs/crime/crime_bg.png) no-repeat",
    backgroundSize: "100% auto",

    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "left top",
      backgroundSize: "auto auto",
    },
  },

  header: {
    width: "100%",
    justifyContent: "space-between",
    display: "flex",
    gap: 32,
    marginTop: 96,
    alignItems: "center",
    boxSizing: "border-box",

    [theme.breakpoints.down("lg")]: {
      padding: "0 32px",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 16,
      marginTop: 32,
    },
  },

  headerLeft: {
    display: "flex",
    gap: 16,
    alignItems: "center",

    "& img": {
      width: 32,
    },
  },

  headerRight: {
    display: "flex",
    gap: 16,
    alignItems: "center",

    "& img": {
      width: 32,
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  prisonerListPanel: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
    backgroundColor: "rgba(28, 30, 31)",
    minHeight: 900,
    width: "100%",
    borderRadius: 24,
    border: "1px solid #000000",
    padding: "24px 48px",
    overflowX: "auto",

    [theme.breakpoints.down("lg")]: {
      padding: "16px 32px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "16px 16px",
    },
  },

  prisonerListHeader: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    padding: "16px 0",
    width: "100%",
    boxSizing: "border-box",
    minWidth: "900px",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF40",

      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
      },
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: 600,
    },
  },

  prisonerListItem: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gap: 16,
    alignItems: "center",
    padding: "8px 0",
    width: "100%",
    boxSizing: "border-box",
    borderBottom: "1px solid #FFFFFF10",
    minWidth: "900px",

    "& a": {
      textDecoration: "none",
      color: theme.palette.text.linkColor,
      fontFamily: "Philosopher",
      fontWeight: 900,

      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
      },
    },

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",

      [theme.breakpoints.down("sm")]: {
        fontSize: 14,
      },
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: 600,
    },
  },

  moneyCopyButton: {
    minWidth: 100,
    borderRadius: 16,
    background: "rgb(255, 255, 255, 0.2)",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,

    "& img": {
      width: 24,
      height: 24,
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: 88,
      padding: "4px",
      fontSize: 14,
    },
  },

  bustOutButton: {
    minWidth: 110,
    borderRadius: 16,
    background: "linear-gradient(317deg, rgb(51 135 55), rgb(98 231 149))",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    textTransform: "none",

    [theme.breakpoints.down("sm")]: {
      minWidth: 80,
      fontSize: 14,
      padding: 4,
    },
  },

  noUserDes: {
    display: "flex",
    justifyContent: "center",
    color: "gray",
    width: "100%",
  },

  headerInfoItem: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
}));

export default styles;
